import { Button } from "@dream/ui";
import { useId, useState } from "react";
import { CLIENT_LOGO_ACCEPT, fileToClientLogoDataUrl } from "../lib/client-logo.ts";
import { ClientMark } from "./client-mark.tsx";

/**
 * Escolha da logomarca no cadastro e no acesso do cliente.
 */

export function ClientLogoField({
  name,
  color,
  previewUrl,
  onPick,
  onClear,
  hint = "Vira o ícone da aba, do PIN e do calendário em /@handle.",
}: {
  name: string;
  color: string;
  previewUrl: string | null;
  onPick: (dataUrl: string) => void;
  onClear: () => void;
  hint?: string;
}) {
  const inputId = useId();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onFile(file: File | undefined): Promise<void> {
    if (file === undefined) return;
    setError(null);
    setBusy(true);
    try {
      onPick(await fileToClientLogoDataUrl(file));
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Não foi possível ler a imagem.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-2">
      <p className="text-[0.8125rem] font-medium text-[var(--color-ink-secondary)]">Logomarca</p>
      <div className="flex items-center gap-3">
        <ClientMark alt={name} color={color} logoUrl={previewUrl} name={name} size={56} />
        <div className="min-w-0 flex-1">
          <input
            id={inputId}
            type="file"
            accept={CLIENT_LOGO_ACCEPT}
            className="sr-only"
            disabled={busy}
            onChange={(event) => {
              const file = event.target.files?.[0];
              event.target.value = "";
              void onFile(file);
            }}
          />
          <div className="flex flex-wrap gap-2">
            <Button
              type="button"
              variant="secondary"
              size="sm"
              loading={busy}
              onClick={() => document.getElementById(inputId)?.click()}
            >
              {previewUrl === null ? "Enviar logo" : "Trocar logo"}
            </Button>
            {previewUrl !== null ? (
              <Button type="button" variant="ghost" size="sm" onClick={onClear}>
                Remover
              </Button>
            ) : null}
          </div>
          <p className="mt-1 text-[0.75rem] leading-5 text-[var(--color-ink-muted)]">{hint}</p>
          {error !== null ? (
            <p role="alert" className="mt-1 text-[0.75rem] font-medium text-[#AB3434]">
              {error}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
